import React, { useEffect, useState } from "react";
import moment from "moment";
import Accordion from "react-bootstrap/Accordion";
import { BankSettlementBeneficiaries } from '../../../helper/Api';


const ReconciliationOverlay = ({
    reconciliationOverlay, 
    setReconciliationOverlay, 
    fy_list, 
    storedGlobalDateId,
    formatNumber,
    dividerNumber,
    handleYearDropdown,
    addElipsis,
    accumulatedDeductionDbt,
    accumulatedDeduction,
    totalTdsIts,
    totalGst,
    totalRoyaltys,
    totalLabour,
    getSingleBeneficiaryReimbursements,
    totalOtherDeduction,
    singleBeneficiarys,
    settlementsInProgress,
    totalPenalty,
    totalWithheld,
    totalOverall,
    withHeldAndPenalty,
    totalOverallAccDeduction,
    totalReimbursementOrderValue
}) => {
    const [bankMailRecords, setBankMailRecords] = useState([]);
    const [openIndex, setOpenIndex] = useState(null);
    const [activeKeys, setActiveKeys] = useState([]);
    const [overlayDropDown, setOverlayDropDown] = useState(false);
    const [subheadAccording, setSubheadAccording] = useState({});
    const [salaryAccording, setSalaryAccording] = useState([]);
    const [totalSettlementAmount, setTotalSettlementAmount] = useState(0);

    const handleSalaryAccording = (salaryId) => {
        const salary = salaryAccording.find(e => e === salaryId);
        if(salary) {
            setSalaryAccording(salaryAccording.filter(e => e !== salaryId));
        } else {
            setSalaryAccording(prev => [...prev, salaryId]);
        }
    }

    const toggleAccordions = (index) => {
        setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    const toggleAccordion = (key) => {
        setActiveKeys(
            (prevKeys) =>
            prevKeys.includes(key)
                ? prevKeys.filter((k) => k !== key) // Remove key if it's already open
                : [...prevKeys, key] // Add key if it's closed
        );
    };

    const fetchBankSettlementBeneficiaries = async () => {
        try {
            const res = await BankSettlementBeneficiaries({onHold: true, details: true});
            if (res.data.status) {
                const total = res.data?.data.reduce((acc, item) => acc + Number(item.amount_paise), 0);
                setTotalSettlementAmount(total / 100);
                setBankMailRecords(res.data.data);
            }
        } catch (error) {
            console.log("fetchBankSettlementBeneficiaries error", error);
        }
    }

    useEffect(() => {
        fetchBankSettlementBeneficiaries();
    }, []);

    const populateSalary = (allData) => {
        const uniqueSalary = [];
        allData?.filter(e => e.salary_id > 0)?.forEach(e => {
            if(uniqueSalary.length) {
                let salary = uniqueSalary.find(f => f.salary_id === e.salary_id);
                if(!salary) {
                    uniqueSalary.push({
                        salary_id: e.salary_id
                    });
                }
            } else {
                uniqueSalary.push({
                    salary_id: e.salary_id
                });
            }
        });
        return uniqueSalary;
    }
    return (
        <div>
            <div className={`overlay  ${reconciliationOverlay ? "d-none" : null}  `}></div>

      <div
        className={`overlayContent overflow-x-hidden overflow-y-auto ${
          reconciliationOverlay ? "left-100" : null
        } `}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-secondary-100 position-relative text-white d-flex justify-content-between align-items-center p-3 position-sticky top-0 z-3">
          <div className="fw-600 fs-16px d-flex align-items-center gap-1 ">
            <i
              className="icon-close_circle_fill fs-5  cursor-pointer"
              onClick={() => setReconciliationOverlay(true)}
            ></i>
            Reconciliation - FY
            <select
              name="financial_year_id"
              onChange={handleYearDropdown}
              className="bg-transparent border-0 text-white fw-500 fs-16px select"
              disabled
            >
              <option value="" className="text-black">
                select year
              </option>
              {fy_list?.map((fy) => {
                return (
                  <option
                    value={storedGlobalDateId}
                    key={fy.id}
                    className="text-black"
                    selected={
                      String(fy.id) === storedGlobalDateId ||
                      (!storedGlobalDateId &&
                        fy.start_year === moment().format("YYYY"))
                    }
                  >
                    {fy.year}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="d-flex gap-2 align-items-center ">
            <span>
              As on date{" "}
              {
                <select
                  name="financial_year_id"
                  className="bg-transparent border-0 text-white fw-500 fs-16px select"
                  disabled
                >
                  <option value="" className="text-black">
                    select year
                  </option>
                  {fy_list?.map((fy) => {
                    return (
                      <option
                        value={storedGlobalDateId}
                        key={fy.id}
                        className="text-black"
                        selected={
                          String(fy.id) === storedGlobalDateId ||
                          (!storedGlobalDateId &&
                            fy.start_year === moment().format("YYYY"))
                        }
                      >
                        {fy.start_year.includes(new Date().getFullYear())
                          ? moment().format("Do MMM YYYY")
                          : "31 Mar " + fy.end_year}
                      </option>
                    );
                  })}
                </select>
              }
            </span>
            <i
              className="icon-arrow_drop_down_circle fs-18px cursor-pointer"
              onClick={() => setOverlayDropDown((prev) => !prev)}
            ></i>

            <div
              className={`position-absolute bg-prime-100 w-100 p-3 ${
                !overlayDropDown ? "d-none" : "d-inline-block"
              }`}
              style={{ top: "100%", zIndex: "10" }}
            >
              <div className="d-flex flex-column gap-4">
                <span className="d-flex align-items-center gap-2">
                  <i className="icon-featured_play_list"></i> Export Excel
                </span>
                <span className="d-flex align-items-center gap-2">
                  <i className="icon-picture_as_pdf"></i> Export PDF
                </span>
                <span className="d-flex align-items-center gap-2">
                  <i className="icon-view_list"></i> List View
                </span>
                <span className="d-flex align-items-center gap-2">
                  <i className="icon-grid_on"></i> Grid View
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="px-4 py-3 d-flex flex-column gap-2">
          <div
            className="bg-white border-Prime-100"
            style={{ borderRadius: "8px" }}
          >
            <div
              className="bg-prime-20 d-flex justify-content-between align-items-center py-2 transition overflow-hidden px-3"
              style={{ borderRadius: "8px 8px 0 0" }}
            >
              {/* ======================card header================== */}
              <span
                className="fs-14px white-space-nowrap overflow-x-hidden"
                style={{ width: "95%" }}
              >
                {/* =======================card header====================== */}
                <span
                  className="fs-14px white-space-nowrap overflow-x-hidden "
                  style={{ width: "95%" }}
                >
                  <span className="fw-500 text-secondary-100">
                    Accumulated deduction
                  </span>
                </span>
              </span>

              <span>
                <i className="icon-filter_alt cursor-pointer p-2 transition bg-active-prime-100 rounded-2"></i>
              </span>
            </div>

            {/* ================== card body ========================= */}

            <div className="row py-2 px-3">
              <div className="row">
                <div className="col-3 d-flex flex-column py-2">
                  <span className="text-black-60 fs-12px">Total Vendor</span>
                  <span className="fw-500 fs-14px">
                    {totalOverallAccDeduction == 0
                      ? "-"
                      : formatNumber(
                          totalOverallAccDeduction / dividerNumber,
                          "indian"
                        )}
                  </span>
                </div>
                <div className="col-3 d-flex flex-column py-2">
                  <span className="text-black-60 fs-12px">Total DBT/Nach</span>
                  <span className="fw-500 fs-14px">
                    {formatNumber(
                      totalReimbursementOrderValue / dividerNumber,
                      "indian"
                    )}
                  </span>
                </div>
                <div className="col-3 d-flex flex-column py-2">
                  <span className="text-black-60 fs-12px">Total Salary</span>
                  <span className="fw-500 fs-14px">-</span>
                </div>
                <div className="col-3 d-flex flex-column bg-success-20 py-2">
                  <span className="text-black-60 fs-12px d-flex justify-content-between align-items-center">
                    Total
                    <span>
                      <i className="icon-info cursor-pointer"></i>
                    </span>
                  </span>
                  <span className="fw-500 fs-14px">
                    {formatNumber(
                      (totalReimbursementOrderValue +
                        totalOverallAccDeduction) /
                        dividerNumber,
                      "indian"
                    )}
                  </span>
                </div>
              </div>
            </div>

            <div className="px-3 pb-2 d-flex flex-column gap-1">
              <Accordion activeKey={activeKeys} style={{ border: "0" }}>
                <Accordion.Item
                  eventKey="0"
                  style={{ borderRadius: "0", border: "0" }}
                >
                  <Accordion.Header
                    onClick={() => toggleAccordion("0")}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      position: "relative",
                      borderRadius: "0",
                      zIndex: "1",
                    }}
                  >
                    <div className="w-100 d-flex justify-content-between">
                      <span>Vendor</span>
                      <span
                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                        style={{ height: "13.33px", width: "13.33px" }}
                      >
                        {activeKeys.includes("0") ? "-" : "+"}
                      </span>
                    </div>
                  </Accordion.Header>

                  <Accordion.Body>
                    <div>
                      {/* ==============================subhead data================================ */}

                      <div
                        className="row fs-12px text-black-60 p-1 mt-1 m-auto"
                        style={{ width: "99%" }}
                      >
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          vendor
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Invoice No/Date
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          TDS IT
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Total TDS GST
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Royalty
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Labour Cess
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Other
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Total
                        </div>
                      </div>
                      <div
                        className="overflow-x-hidden overflow-y-auto"
                        style={{ maxHeight: "200px", height: "auto" }}
                      >
                        {accumulatedDeduction?.map((val, ind) => (
                          <div
                            className="row fs-14px p-1 fw-500 overflow-hidden ps-3"
                            style={{
                              height: "35px",
                              background:
                                ind % 2 === 0 ? "#F8F8F8" : "transparent",
                            }}
                          >
                            {/* <div className="row fs-14px p-1 fw-500" style={{background: "#F8F8F8"}}> */}
                            <div className="col p-0" style={{ width: "20%" }}>
                              {val?.company_name}
                            </div>
                            <div className="col p-0" style={{ width: "20%" }}>
                              {addElipsis(
                                val?.invoice_no + " | " + val?.invoice_date,
                                13
                              )}
                            </div>
                            <div className="col p-0" style={{ width: "20%" }}>
                              {val?.tds_it_amount == 0
                                ? "-"
                                : formatNumber(
                                    val?.tds_it_amount / dividerNumber,
                                    "indian"
                                  )}
                            </div>
                            <div className="col p-0" style={{ width: "20%" }}>
                              {Number(val?.c_gst_amount) +
                                Number(val?.i_gst_amount) +
                                Number(val?.s_gst_amount) ==
                              0
                                ? "-"
                                : formatNumber(
                                    (Number(val?.c_gst_amount) +
                                      Number(val?.i_gst_amount) +
                                      Number(val?.s_gst_amount)) /
                                      dividerNumber,
                                    "indian"
                                  )}
                            </div>
                            <div className="col p-0" style={{ width: "20%" }}>
                              {val?.royalty_amount == 0
                                ? "-"
                                : formatNumber(
                                    val?.royalty_amount / dividerNumber,
                                    "indian"
                                  )}
                            </div>
                            <div className="col p-0" style={{ width: "20%" }}>
                              {val?.labour_amount == 0
                                ? "-"
                                : formatNumber(
                                    val?.labour_amount / dividerNumber,
                                    "indian"
                                  )}
                            </div>
                            <div className="col p-0" style={{ width: "20%" }}>
                              {val?.other_deduction == null
                                ? "-"
                                : val?.other_deduction == 0
                                ? "-"
                                : formatNumber(
                                    val?.other_deduction / dividerNumber,
                                    "indian"
                                  )}
                            </div>
                            <div
                              className="col p-0 text-success-100"
                              style={{ width: "20%" }}
                            >
                              {Number(val?.tds_it_amount) +
                                Number(val?.c_gst_amount) +
                                Number(val?.i_gst_amount) +
                                Number(val?.s_gst_amount) +
                                Number(val?.royalty_amount) +
                                Number(val?.labour_amount) +
                                Number(
                                  val?.other_deduction == null
                                    ? "0"
                                    : val?.other_deduction
                                ) ==
                              0
                                ? "-"
                                : formatNumber(
                                    (Number(val?.tds_it_amount) +
                                      Number(val?.c_gst_amount) +
                                      Number(val?.i_gst_amount) +
                                      Number(val?.s_gst_amount) +
                                      Number(val?.royalty_amount) +
                                      Number(val?.labour_amount) +
                                      Number(
                                        val?.other_deduction == null
                                          ? "0"
                                          : val?.other_deduction
                                      )) /
                                      dividerNumber,
                                    "indian"
                                  )}
                            </div>
                          </div>
                        ))}
                      </div>

                      <div
                        className="row fs-14px p-1 fw-500 overflow-hidden bg-info-20 m-auto"
                        style={{
                          height: "30px",
                          width: "99.9%",
                        }}
                      >
                        {/* <div className="row fs-14px p-1 fw-500" style={{background: "#F8F8F8"}}> */}
                        <div className="col p-0" style={{ width: "20%" }}>
                          Total
                        </div>
                        <div className="col p-0" style={{ width: "20%" }}></div>
                        <div className="col p-0" style={{ width: "20%" }}>
                          {totalTdsIts == 0
                            ? "-"
                            : formatNumber(
                                totalTdsIts / dividerNumber,
                                "indian"
                              )}
                        </div>
                        <div className="col p-0" style={{ width: "20%" }}>
                          {totalGst == 0
                            ? "-"
                            : formatNumber(totalGst / dividerNumber, "indian")}
                        </div>
                        <div className="col p-0" style={{ width: "20%" }}>
                          {totalRoyaltys == 0
                            ? "-"
                            : formatNumber(
                                totalRoyaltys / dividerNumber,
                                "indian"
                              )}
                        </div>
                        <div className="col p-0" style={{ width: "20%" }}>
                          {totalLabour == 0
                            ? "-"
                            : formatNumber(
                                totalLabour / dividerNumber,
                                "indian"
                              )}
                        </div>
                        <div className="col p-0" style={{ width: "20%" }}>
                          {totalOtherDeduction == 0
                            ? "-"
                            : formatNumber(
                                totalOtherDeduction / dividerNumber,
                                "indian"
                              )}
                        </div>
                        <div
                          className="col p-0 text-success-100"
                          style={{ width: "20%" }}
                        >
                          {/* {totalOverallAccDeduction == 0
                            ? "-"
                            : formatNumber(
                                totalOverallAccDeduction / dividerNumber,
                                "indian"
                              )} */}
                        </div>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              {/* ===================DBT accordion=================== */}

              <Accordion style={{ border: "0" }}>
                <Accordion.Item
                  eventKey="15"
                  style={{ borderRadius: "0", border: "0" }}
                >
                  <Accordion.Header
                    onClick={() => toggleAccordion("15")}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      position: "relative",
                      borderRadius: "0",
                    }}
                  >
                    <div className="w-100 d-flex justify-content-between">
                      <span>DBT/NACH</span>
                      <span
                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                        style={{ height: "13.33px", width: "13.33px" }}
                      >
                        {activeKeys.includes("15") ? "-" : "+"}
                      </span>
                    </div>
                  </Accordion.Header>

                  <Accordion.Body>
                    <div>
                      {/* ==============================subhead data================================ */}

                      <div className="row fs-12px text-black-60 p-1 mt-1">
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Department Level/Name
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Order No./Date
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Scheme/Subhead Code
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Gross Amount
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Deduction
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Net Amount
                        </div>
                      </div>
                      {accumulatedDeductionDbt?.map((val, ind) => (
                        <div
                          className="row fs-14px p-1 fw-500 overflow-hidden"
                          style={{
                            height: openIndex !== ind ? "35px" : "fit-content",
                          }}
                          onClick={() =>
                            getSingleBeneficiaryReimbursements(val?.id)
                          }
                        >
                          <div
                            className="row fs-14px p-1 fw-500"
                            style={{
                              background:
                                ind % 2 === 0 ? "#F8F8F8" : "transparent",
                            }}
                          >
                            <div
                              className="col d-flex align-items-center"
                              style={{ widows: "20%" }}
                            >
                              {openIndex === ind ? (
                                <i
                                  className="icon-keyboard_arrow_down cursor-pointer"
                                  onClick={() => toggleAccordions(ind)}
                                ></i>
                              ) : (
                                <i
                                  className="icon-keyboard_arrow_right cursor-pointer"
                                  onClick={() => toggleAccordions(ind)}
                                ></i>
                              )}
                              <span>{addElipsis(val?.department, 13)}</span>
                            </div>

                            <div className="col" style={{ width: "20%" }}>
                              {addElipsis(
                                val?.reimbursement_order_no +
                                  " | " +
                                  val?.reimbursement_order_date,
                                13
                              )}
                            </div>
                            <div className="col" style={{ width: "20%" }}>
                              {addElipsis(
                                val?.code + " | " + val?.subhead_code,
                                13
                              )}
                            </div>
                            <div className="col" style={{ width: "20%" }}>
                              {val?.reimbursement_order_value}
                            </div>
                            <div className="col" style={{ width: "20%" }}>
                              {val?.deduction_amount}
                            </div>
                            <div className="col" style={{ width: "20%" }}>
                              {Number(val?.reimbursement_order_value) -
                                Number(val?.deduction_amount)}
                            </div>
                          </div>

                          <div className="mt-1 p-0 pe-3">
                            <table className="border-0">
                              <tr className="bg-prime-20 border-0">
                                <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                  Name
                                </th>
                                <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                  Mobile/Email
                                </th>
                                <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                  IFSC
                                </th>
                                <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                  Gross Amount
                                </th>
                                <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                  Deduction
                                </th>
                                <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                  Net Amount
                                </th>
                              </tr>
                              {singleBeneficiarys.map((val, ind) => (
                                <tr>
                                  <td className="p-1 border-0 text-start fs-12px text-black-100">
                                    {val?.name}
                                  </td>
                                  <td className="p-1 border-0 text-start fs-12px text-black-100">
                                    {val?.mobile} | {val?.email}
                                  </td>
                                  <td className="p-1 border-0 text-start fs-12px text-black-100">
                                    {val?.ifsc}
                                  </td>
                                  <td className="p-1 border-0 text-start fs-12px text-black-100">
                                    {val?.gross_amount}
                                  </td>
                                  <td className="p-1 border-0 text-start fs-12px text-black-100">
                                    {val?.deduction_amount}
                                  </td>
                                  <td className="p-1 border-0 text-start fs-12px text-black-100">
                                    {Number(val?.gross_amount) -
                                      Number(val?.deduction_amount)}
                                  </td>
                                </tr>
                              ))}
                            </table>
                          </div>
                        </div>
                      ))}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              {/* ===================salary accordion=================== */}

              <Accordion style={{ border: "0" }}>
                <Accordion.Item
                  eventKey="101"
                  style={{ borderRadius: "0", border: "0" }}
                >
                  <Accordion.Header
                    onClick={() => toggleAccordion("101")}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      position: "relative",
                      borderRadius: "0",
                    }}
                  >
                    <div className="w-100 d-flex justify-content-between">
                      <span>Salary</span>
                      <span
                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                        style={{ height: "13.33px", width: "13.33px" }}
                      >
                        {activeKeys.includes("101") ? "-" : "+"}
                      </span>
                    </div>
                  </Accordion.Header>

                  <Accordion.Body>
                    <div>
                      <div className="row fs-12px text-black-60 p-1 mt-1">
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Department Level/Name
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Scheme/Subhead Code
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Order No./Date
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Amount
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Transaction Date
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          UTL No./Transaction ID
                        </div>
                      </div>

                      <div
                        className="row fs-14px p-1 fw-500 overflow-hidden"
                        style={{
                          height: "35px",
                        }}
                      >
                        <div
                          className="row fs-14px p-1 fw-500"
                          style={{ background: "#F8F8F8" }}
                        >
                          <div
                            className="col d-flex align-items-center"
                            style={{ widows: "20%" }}
                          >
                            <span>radhe krishna</span>
                          </div>

                          <div className="col" style={{ width: "20%" }}>
                            25412
                          </div>
                          <div className="col" style={{ width: "20%" }}>
                            25412 | 10/08/2025
                          </div>
                          <div className="col" style={{ width: "20%" }}>
                            2,000,000,000.00
                          </div>
                          <div className="col" style={{ width: "20%" }}>
                            2,000,000,000.00
                          </div>
                          <div className="col" style={{ width: "20%" }}>
                            2,000,000,000.00
                          </div>
                        </div>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>

          {/* =============================settlement in progress card==================== */}
          <div
            className="bg-white border-Prime-100"
            style={{ borderRadius: "8px" }}
          >
            <div
              className="bg-prime-20 d-flex justify-content-between align-items-center py-2 transition overflow-hidden px-3"
              style={{ borderRadius: "8px 8px 0 0" }}
            >
              {/* ======================card header================== */}
              <span
                className="fs-14px white-space-nowrap overflow-x-hidden"
                style={{ width: "95%" }}
              >
                {/* =======================card header====================== */}
                <span
                  className="fs-14px white-space-nowrap overflow-x-hidden "
                  style={{ width: "95%" }}
                >
                  <span className="fw-500 text-secondary-100">
                    Settlements In Progress
                  </span>
                </span>
              </span>

              <span>
                <i className="icon-filter_alt cursor-pointer p-2 transition bg-active-prime-100 rounded-2"></i>
              </span>
            </div>

            {/* ================== card body ========================= */}

            <div className="row py-2 px-3">
              <div className="row">
                <div className="col-4 d-flex flex-column py-2"></div>
                <div className="col-4 d-flex flex-column py-2"></div>
                <div className="col-4 d-flex flex-column bg-success-20 py-2">
                  <span className="text-black-60 fs-12px d-flex justify-content-between align-items-center">
                    Total
                    <span>
                      <i className="icon-info cursor-pointer"></i>
                    </span>
                  </span>
                  <span className="fw-500 fs-14px">{totalSettlementAmount}</span>
                </div>
              </div>
            </div>
            <div className="px-3 pb-2 d-flex flex-column gap-1">
              <Accordion activeKey={activeKeys} style={{ border: "0" }}>
                <Accordion.Item
                  eventKey="17"
                  style={{ borderRadius: "0", border: "0" }}
                >
                  <Accordion.Header
                    onClick={() => toggleAccordion("17")}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      position: "relative",
                      borderRadius: "0",
                    }}
                  >
                    <div className="w-100 d-flex justify-content-between">
                      <span>Vendor</span>
                      <span
                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                        style={{ height: "13.33px", width: "13.33px" }}
                      >
                        {activeKeys.includes("17") ? "-" : "+"}
                      </span>
                    </div>
                  </Accordion.Header>

                  <Accordion.Body>
                    <div>
                      {/* ==============================subhead data================================ */}

                      <div
                        className="row fs-12px text-black-60 p-1 mt-1 m-auto"
                        style={{ width: "99%" }}
                      >
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          vendor
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Invoice No/Date
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Sanction Order/Date
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Amount
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Transaction Date
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          UTR No./Transaction ID
                        </div>
                      </div>
                      <div
                        className="overflow-x-hidden overflow-y-auto"
                        style={{ maxHeight: "200px", height: "auto" }}
                      >
                        {bankMailRecords.filter(e => e.invoice_id > 0)?.map((val, ind) => (
                          <div
                            className="row fs-14px p-1 fw-500 overflow-hidden ps-3"
                            style={{
                              height: "35px",
                              background:
                                ind % 2 === 0 ? "#F8F8F8" : "transparent",
                            }}
                          >
                            <div className="col p-0" style={{ width: "20%" }}>
                              {val?.beneficiary_name}
                            </div>
                            <div className="col p-0" style={{ width: "20%" }}>
                              {addElipsis(
                                val?.invoice_no + " | " + val?.invoice_date,
                                15
                              )}
                            </div>
                            <div className="col p-0" style={{ width: "20%" }}>
                              {addElipsis(
                                val?.sanction_order_no +
                                  " | " +
                                  val?.sanction_order_date,
                                15
                              )}
                            </div>
                            <div className="col p-0" style={{ width: "20%" }}>
                              {val?.amount_paise / 100}
                            </div>
                            <div className="col p-0" style={{ width: "20%" }}>
                              {val?.created_at}
                            </div>
                            <div className="col p-0" style={{ width: "20%" }}>
                              {val?.id}
                            </div>
                          </div>
                        ))}
                      </div>

                      <div
                        className="row fs-14px p-1 fw-500 overflow-hidden bg-info-20 m-auto"
                        style={{
                          height: "30px",
                          width: "99.99%",
                        }}
                      >
                        {/* <div className="row fs-14px p-1 fw-500" style={{background: "#F8F8F8"}}> */}
                        <div className="col p-0" style={{ width: "20%" }}>
                          Total
                        </div>
                        <div className="col p-0" style={{ width: "20%" }}></div>
                        <div className="col p-0" style={{ width: "20%" }}></div>
                        <div className="col p-0" style={{ width: "20%" }}>
                          {bankMailRecords?.filter(e => e.invoice_id > 0)?.reduce((acc, item) => acc + (Number(item.amount_paise) / 100), 0)}
                        </div>
                        <div className="col p-0" style={{ width: "20%" }}></div>
                        <div className="col p-0 text-success-100" style={{ width: "20%" }}></div>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              {/* ===================DBT accordion=================== */}

              <Accordion style={{ border: "0" }}>
                <Accordion.Item
                  eventKey="16"
                  style={{ borderRadius: "0", border: "0" }}
                >
                  <Accordion.Header
                    onClick={() => toggleAccordion("16")}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      position: "relative",
                      borderRadius: "0",
                    }}
                  >
                    <div className="w-100 d-flex justify-content-between">
                      <span>DBT/NACH</span>
                      <span
                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                        style={{ height: "13.33px", width: "13.33px" }}
                      >
                        {activeKeys.includes("16") ? "-" : "+"}
                      </span>
                    </div>
                  </Accordion.Header>

                  <Accordion.Body>
                    <div>
                      <div className="row fs-12px text-black-60 p-1 mt-1">
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Department Level/Name
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Scheme/Subhead Code
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Order No./Date
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Amount
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Transaction Date
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          UTL No./Transaction ID
                        </div>
                      </div>

                        <div className="row fs-14px p-1 fw-500 overflow-hidden" style={{ height: subheadAccording ? "35px" : "fit-content", }} >
                            <div
                            className="row fs-14px p-1 fw-500"
                            style={{ background: "#F8F8F8" }}
                            >
                            <div
                                className="col d-flex align-items-center"
                                style={{ widows: "20%" }}
                            >
                                {subheadAccording ? (
                                <i
                                    className="icon-keyboard_arrow_right cursor-pointer"
                                    onClick={() =>
                                    setSubheadAccording((prev) => !prev)
                                    }
                                ></i>
                                ) : (
                                <i
                                    className="icon-keyboard_arrow_down cursor-pointer"
                                    onClick={() =>
                                    setSubheadAccording((prev) => !prev)
                                    }
                                ></i>
                                )}
                                <span>radhe krishna</span>
                            </div>

                            <div className="col" style={{ width: "20%" }}>
                                25412
                            </div>
                            <div className="col" style={{ width: "20%" }}>
                                25412 | 10/08/2025
                            </div>
                            <div className="col" style={{ width: "20%" }}>
                                2,000,000,000.00
                            </div>
                            <div className="col" style={{ width: "20%" }}>
                                2,000,000,000.00
                            </div>
                            <div className="col" style={{ width: "20%" }}>
                                2,000,000,000.00
                            </div>
                            </div>

                            <div className="mt-1 p-0 pe-3">
                            <table className="border-0">
                                <tr className="bg-prime-20 border-0">
                                <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                    Name
                                </th>
                                <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                    Mobile/Email
                                </th>
                                <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                    Action/IFSC
                                </th>
                                <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                    Gross Amount
                                </th>
                                <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                    Deduction
                                </th>
                                <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                    Net Amount
                                </th>
                                </tr>
                                <tr>
                                <td className="p-1 border-0 text-start fs-12px text-black-100">
                                    radha krishna
                                </td>
                                <td className="p-1 border-0 text-start fs-12px text-black-100">
                                    123456780
                                </td>
                                <td className="p-1 border-0 text-start fs-12px text-black-100">
                                    123456780
                                </td>
                                <td className="p-1 border-0 text-start fs-12px text-black-100">
                                    123456780
                                </td>
                                <td className="p-1 border-0 text-start fs-12px text-black-100">
                                    123456780
                                </td>
                                <td className="p-1 border-0 text-start fs-12px text-black-100">
                                    123456780
                                </td>
                                </tr>
                            </table>
                            </div>
                        </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              {/* ===================salary accordion=================== */}

              <Accordion style={{ border: "0" }}>
                <Accordion.Item
                  eventKey="100"
                  style={{ borderRadius: "0", border: "0" }}
                >
                  <Accordion.Header
                    onClick={() => toggleAccordion("100")}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      position: "relative",
                      borderRadius: "0",
                    }}
                  >
                    <div className="w-100 d-flex justify-content-between">
                      <span>Salary</span>
                      <span
                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                        style={{ height: "13.33px", width: "13.33px" }}
                      >
                        {activeKeys.includes("100") ? "-" : "+"}
                      </span>
                    </div>
                  </Accordion.Header>

                  <Accordion.Body>
                    <div>
                      <div className="row fs-12px text-black-60 p-1 mt-1">
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Salary ID
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Scheme/Subhead Code
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Order No./Date
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Amount
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Transaction Date
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          UTL No./Transaction ID
                        </div>
                      </div>
                        {
                            populateSalary(bankMailRecords)?.map(e => (
                                <div className="row fs-14px p-1 fw-500 overflow-hidden" style={{ height: salaryAccording.includes(e.salary_id) ? "35px" : "fit-content", }} >
                                    <div
                                    className="row fs-14px p-1 fw-500"
                                    style={{ background: "#F8F8F8" }}
                                    >
                                    <div
                                        className="col d-flex align-items-center"
                                        style={{ widows: "20%" }}
                                    >
                                        {salaryAccording.includes(e.salary_id) ? (
                                        <i
                                            className="icon-keyboard_arrow_right cursor-pointer"
                                            onClick={() =>
                                            handleSalaryAccording(e.salary_id)
                                            }
                                        ></i>
                                        ) : (
                                        <i
                                            className="icon-keyboard_arrow_down cursor-pointer"
                                            onClick={() =>
                                            handleSalaryAccording(e.salary_id)
                                            }
                                        ></i>
                                        )}
                                        <span>{e.salary_id}</span>
                                    </div>

                                    <div className="col" style={{ width: "20%" }}>
                                        25412
                                    </div>
                                    <div className="col" style={{ width: "20%" }}>
                                        25412 | 10/08/2025
                                    </div>
                                    <div className="col" style={{ width: "20%" }}>
                                        2,000,000,000.00
                                    </div>
                                    <div className="col" style={{ width: "20%" }}>
                                        2,000,000,000.00
                                    </div>
                                    <div className="col" style={{ width: "20%" }}>
                                        2,000,000,000.00
                                    </div>
                                    </div>

                                    <div className="mt-1 p-0 pe-3">
                                        <table className="border-0">
                                            <tr className="bg-prime-20 border-0">
                                                <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                                    Name
                                                </th>
                                                <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                                    Account No
                                                </th>
                                                <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                                    IFSC
                                                </th>
                                                <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                                    Gross Amount
                                                </th>
                                                <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                                    Transaction Date
                                                </th>
                                                <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                                    UTR No. / Transaction ID
                                                </th>
                                            </tr>
                                            {
                                                bankMailRecords?.filter(b => b.salary_id === e.salary_id)?.map(s => (
                                                    <tr>
                                                        <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                            {s.beneficiary_name}
                                                        </td>
                                                        <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                            {s.beneficiary_account_no}
                                                        </td>
                                                        <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                            {s.destination_ifsc_micr_iin}
                                                        </td>
                                                        <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                            {s.amount_paise / 100}
                                                        </td>
                                                        <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                            {s.created_at}
                                                        </td>
                                                        <td className="p-1 border-0 text-start fs-12px text-black-100">
                                                            {s.id}
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </table>
                                    </div>
                                </div>
                            ))
                        }
                        
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>

          {/* =============================with held and penalty card==================== */}
          <div
            className="bg-white border-Prime-100"
            style={{ borderRadius: "8px" }}
          >
            <div
              className="bg-prime-20 d-flex justify-content-between align-items-center py-2 transition overflow-hidden px-3"
              style={{ borderRadius: "8px 8px 0 0" }}
            >
              {/* ======================card header================== */}
              <span
                className="fs-14px white-space-nowrap overflow-x-hidden"
                style={{ width: "95%" }}
              >
                {/* =======================card header====================== */}
                <span
                  className="fs-14px white-space-nowrap overflow-x-hidden "
                  style={{ width: "95%" }}
                >
                  <span className="fw-500 text-secondary-100">
                    With held and penalty
                  </span>
                </span>
              </span>

              <span>
                <i className="icon-filter_alt cursor-pointer p-2 transition bg-active-prime-100 rounded-2"></i>
              </span>
            </div>

            {/* ================== card body ========================= */}

            <div className="row py-2 px-3">
              <div className="row">
                <div className="col-4 d-flex flex-column py-2">
                  <span className="text-black-60 fs-12px">With Held</span>
                  <span className="fw-500 fs-14px">
                    {totalWithheld == 0
                      ? "-"
                      : formatNumber(totalWithheld / dividerNumber, "indian")}
                  </span>
                </div>
                <div className="col-4 d-flex flex-column py-2">
                  <span className="text-black-60 fs-12px">Penalty</span>
                  <span className="fw-500 fs-14px">
                    {totalPenalty == 0
                      ? "-"
                      : formatNumber(totalPenalty / dividerNumber, "indian")}
                  </span>
                </div>
                <div className="col-4 d-flex flex-column bg-success-20 py-2">
                  <span className="text-black-60 fs-12px d-flex justify-content-between align-items-center">
                    Total
                    <span>
                      <i className="icon-info cursor-pointer"></i>
                    </span>
                  </span>
                  <span className="fw-500 fs-14px">
                    {totalOverall == 0
                      ? "-"
                      : formatNumber(totalOverall / dividerNumber, "india")}
                  </span>
                </div>
              </div>
            </div>

            <div className="px-3 pb-2 d-flex flex-column gap-1">
              <Accordion activeKey={activeKeys} style={{ border: "0" }}>
                <Accordion.Item
                  eventKey="18"
                  style={{ borderRadius: "0", border: "0" }}
                >
                  <Accordion.Header
                    onClick={() => toggleAccordion("18")}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      position: "relative",
                      borderRadius: "0",
                    }}
                  >
                    <div className="w-100 d-flex justify-content-between">
                      <span>Vendor </span>
                      <span
                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                        style={{ height: "13.33px", width: "13.33px" }}
                      >
                        {activeKeys.includes("18") ? "-" : "+"}
                      </span>
                    </div>
                  </Accordion.Header>

                  <Accordion.Body>
                    <div>
                      {/* ==============================subhead data================================ */}

                      <div
                        className="row fs-12px text-black-60 p-1 mt-1 m-auto"
                        style={{ maxHeight: "200px", height: "auto" }}
                      >
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          vendor
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Invoice No/Date
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          With held
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Penalty
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Total
                        </div>
                      </div>
                      <div
                        className="overflow-x-hidden overflow-y-auto"
                        style={{ maxHeight: "200px", height: "auto" }}
                      >
                        {withHeldAndPenalty?.map((val, ind) => (
                          <div
                            className="row ps-3 fs-14px p-1 fw-500 overflow-hidden"
                            style={{
                              height: "30px",
                              background:
                                ind % 2 === 0 ? "#F8F8F8" : "transparent",
                            }}
                          >
                            {/* <div className="row fs-14px p-1 fw-500" style={{background: "#F8F8F8"}}> */}
                            <div className="col p-0" style={{ width: "20%" }}>
                              {val?.company_name}
                            </div>
                            <div className="col p-0" style={{ width: "20%" }}>
                              {addElipsis(
                                val?.invoice_no + " | " + val?.invoice_date,
                                15
                              )}
                            </div>
                            <div className="col p-0" style={{ width: "20%" }}>
                              {val?.withheld_amount == 0
                                ? "-"
                                : formatNumber(
                                    val?.withheld_amount / dividerNumber,
                                    "indian"
                                  )}
                            </div>
                            <div className="col p-0" style={{ width: "20%" }}>
                              {val?.penalty_amount == 0
                                ? "-"
                                : formatNumber(
                                    val?.penalty_amount / dividerNumber,
                                    "indian"
                                  )}
                            </div>
                            <div
                              className="col p-0 text-success-100"
                              style={{ width: "20%" }}
                            >
                              {Number(val?.withheld_amount) +
                                Number(val?.penalty_amount) ==
                              0
                                ? "-"
                                : formatNumber(
                                    (Number(val?.withheld_amount) +
                                      Number(val?.penalty_amount)) /
                                      dividerNumber,
                                    "indian"
                                  )}
                            </div>
                          </div>
                        ))}
                      </div>
                      <div
                        className="row fs-14px p-1 fw-500 overflow-hidden bg-info-20 m-auto"
                        style={{
                          height: "30px",
                          width: "99.99%",
                        }}
                      >
                        {/* <div className="row fs-14px p-1 fw-500" style={{background: "#F8F8F8"}}> */}
                        <div className="col p-0" style={{ width: "20%" }}>
                          Total
                        </div>
                        <div className="col p-0" style={{ width: "20%" }}></div>
                        <div className="col p-0" style={{ width: "20%" }}>
                          {totalWithheld == 0
                            ? "-"
                            : formatNumber(
                                totalWithheld / dividerNumber,
                                "indian"
                              )}
                        </div>
                        <div className="col p-0" style={{ width: "20%" }}>
                          {totalPenalty == 0
                            ? "-"
                            : formatNumber(
                                totalPenalty / dividerNumber,
                                "indian"
                              )}
                        </div>
                        <div
                          className="col p-0 text-success-100"
                          style={{ width: "20%" }}
                        >
                          {totalOverall == 0
                            ? "-"
                            : formatNumber(
                                totalOverall / dividerNumber,
                                "indian"
                              )}
                        </div>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              {/* ===================DBT accordion=================== */}

              <Accordion style={{ border: "0" }}>
                <Accordion.Item
                  eventKey="19"
                  style={{ borderRadius: "0", border: "0" }}
                >
                  <Accordion.Header
                    onClick={() => toggleAccordion("19")}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      position: "relative",
                      borderRadius: "0",
                    }}
                  >
                    <div className="w-100 d-flex justify-content-between">
                      <span>DBT/NACH</span>
                      <span
                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                        style={{ height: "13.33px", width: "13.33px" }}
                      >
                        {activeKeys.includes("19") ? "-" : "+"}
                      </span>
                    </div>
                  </Accordion.Header>

                  <Accordion.Body>
                    <div>
                      <div className="row fs-12px text-black-60 p-1 mt-1">
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Department Level/Name
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Scheme/Subhead Code
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Order No./Date
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Amount
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Transaction Date
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          UTL No./Transaction ID
                        </div>
                      </div>

                      <div
                        className="row fs-14px p-1 fw-500 overflow-hidden"
                        style={{
                          height: subheadAccording ? "35px" : "fit-content",
                        }}
                      >
                        <div
                          className="row fs-14px p-1 fw-500"
                          style={{ background: "#F8F8F8" }}
                        >
                          <div
                            className="col d-flex align-items-center"
                            style={{ widows: "20%" }}
                          >
                            {subheadAccording ? (
                              <i
                                className="icon-keyboard_arrow_right cursor-pointer"
                                onClick={() =>
                                  setSubheadAccording((prev) => !prev)
                                }
                              ></i>
                            ) : (
                              <i
                                className="icon-keyboard_arrow_down cursor-pointer"
                                onClick={() =>
                                  setSubheadAccording((prev) => !prev)
                                }
                              ></i>
                            )}
                            <span>radhe krishna</span>
                          </div>

                          <div className="col" style={{ width: "20%" }}>
                            25412
                          </div>
                          <div className="col" style={{ width: "20%" }}>
                            25412 | 10/08/2025
                          </div>
                          <div className="col" style={{ width: "20%" }}>
                            2,000,000,000.00
                          </div>
                          <div className="col" style={{ width: "20%" }}>
                            2,000,000,000.00
                          </div>
                          <div className="col" style={{ width: "20%" }}>
                            2,000,000,000.00
                          </div>
                        </div>

                        <div className="mt-1 p-0 pe-3">
                          <table className="border-0">
                            <tr className="bg-prime-20 border-0">
                              <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                Name
                              </th>
                              <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                Mobile/Email
                              </th>
                              <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                Action/IFSC
                              </th>
                              <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                Gross Amount
                              </th>
                              <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                Deduction
                              </th>
                              <th className="p-1 border-0 text-start fs-12px text-black-60 fw-500">
                                Net Amount
                              </th>
                            </tr>
                            <tr>
                              <td className="p-1 border-0 text-start fs-12px text-black-100">
                                radha krishna
                              </td>
                              <td className="p-1 border-0 text-start fs-12px text-black-100">
                                123456780
                              </td>
                              <td className="p-1 border-0 text-start fs-12px text-black-100">
                                123456780
                              </td>
                              <td className="p-1 border-0 text-start fs-12px text-black-100">
                                123456780
                              </td>
                              <td className="p-1 border-0 text-start fs-12px text-black-100">
                                123456780
                              </td>
                              <td className="p-1 border-0 text-start fs-12px text-black-100">
                                123456780
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              {/* ===================salary accordion=================== */}

              <Accordion style={{ border: "0" }}>
                <Accordion.Item
                  eventKey="102"
                  style={{ borderRadius: "0", border: "0" }}
                >
                  <Accordion.Header
                    onClick={() => toggleAccordion("102")}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      position: "relative",
                      borderRadius: "0",
                    }}
                  >
                    <div className="w-100 d-flex justify-content-between">
                      <span>Salary</span>
                      <span
                        className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                        style={{ height: "13.33px", width: "13.33px" }}
                      >
                        {activeKeys.includes("102") ? "-" : "+"}
                      </span>
                    </div>
                  </Accordion.Header>

                  <Accordion.Body>
                    <div>
                      <div className="row fs-12px text-black-60 p-1 mt-1">
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Department Level/Name
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Scheme/Subhead Code
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Order No./Date
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Amount
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          Transaction Date
                        </div>
                        <div
                          className="col text-start p-0"
                          style={{ width: "20%" }}
                        >
                          UTL No./Transaction ID
                        </div>
                      </div>

                      <div
                        className="row fs-14px p-1 fw-500 overflow-hidden"
                        style={{
                          height: "35px",
                        }}
                      >
                        <div
                          className="row fs-14px p-1 fw-500"
                          style={{ background: "#F8F8F8" }}
                        >
                          <div
                            className="col d-flex align-items-center"
                            style={{ widows: "20%" }}
                          >
                            <span>radhe krishna</span>
                          </div>

                          <div className="col" style={{ width: "20%" }}>
                            25412
                          </div>
                          <div className="col" style={{ width: "20%" }}>
                            25412 | 10/08/2025
                          </div>
                          <div className="col" style={{ width: "20%" }}>
                            2,000,000,000.00
                          </div>
                          <div className="col" style={{ width: "20%" }}>
                            2,000,000,000.00
                          </div>
                          <div className="col" style={{ width: "20%" }}>
                            2,000,000,000.00
                          </div>
                        </div>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>

          {/* =============================with held interest card==================== */}

          {/* <div
              className="bg-white border-Prime-100"
              style={{ borderRadius: "8px" }}
            >
              <div
                className="bg-prime-20 d-flex justify-content-between align-items-center py-2 transition overflow-hidden px-3"
                style={{ borderRadius: "8px 8px 0 0" }}
              >
                <span
                  className="fs-14px white-space-nowrap overflow-x-hidden"
                  style={{ width: "95%" }}
                >

                  <span
                    className="fs-14px white-space-nowrap overflow-x-hidden "
                    style={{ width: "95%" }}
                  >
                    <span className="fw-500 text-secondary-100">
                      With held interest
                    </span>
                  </span>
                </span>

                <span>
                  <i className="icon-filter_alt cursor-pointer p-2 transition bg-active-prime-100 rounded-2"></i>
                </span>
              </div>


              <div className="row py-2 px-3">
                <div className="row">
                  <div className="col-4 d-flex flex-column py-2">
                    <span className="text-black-60 fs-12px">Interest Earn</span>
                    <span className="fw-500 fs-14px">2,000,000,000.00</span>
                  </div>
                  <div className="col-4 d-flex flex-column py-2">
                    <span className="text-black-60 fs-12px">
                      Interest Deposit
                    </span>
                    <span className="fw-500 fs-14px">2,000,000,000.00</span>
                  </div>
                  <div className="col-4 d-flex flex-column bg-success-20 py-2">
                    <span className="text-black-60 fs-12px d-flex justify-content-between align-items-center">Total 
                    <span>
                         <i className="icon-info cursor-pointer"></i>
                        </span>
                    </span>
                    <span className="fw-500 fs-14px">2,000,000,000.00</span>
                  </div>
                </div>
              </div>
              <div className="px-3 pb-2 d-flex flex-column gap-1">
                <Accordion activeKey={activeKeys} style={{ border: "0" }}>
                  <Accordion.Item
                    eventKey="20"
                    style={{ borderRadius: "0", border: "0" }}
                  >
                    <Accordion.Header
                      onClick={() => toggleAccordion("20")}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        position: "relative",
                        borderRadius: "0",
                      }}
                    >
                      <div className="w-100 d-flex justify-content-between">
                        <span>Interest earn </span>
                        <span
                          className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                          style={{ height: "13.33px", width: "13.33px" }}
                        >
                          {activeKeys.includes("20") ? "-" : "+"}
                        </span>
                      </div>
                    </Accordion.Header>

                    <Accordion.Body>
                      <div>

                        <div className="row fs-12px text-black-60 p-1 mt-1">
                          <div
                            className="col text-start p-0"
                            style={{ width: "20%" }}
                          >
                            Account
                          </div>
                          <div
                            className="col text-start p-0"
                            style={{ width: "20%" }}
                          >
                            Account Number
                          </div>
                          <div
                            className="col text-start p-0"
                            style={{ width: "20%" }}
                          >
                            IFSC Code
                          </div>
                          <div
                            className="col text-start p-0"
                            style={{ width: "20%" }}
                          >
                            Date
                          </div>
                          <div
                            className="col text-start p-0"
                            style={{ width: "20%" }}
                          >
                            Quarter
                          </div>
                          <div
                            className="col text-start p-0"
                            style={{ width: "20%" }}
                          >
                            Amount
                          </div>
                        </div>

                        <div
                          className="row fs-14px p-1 fw-500 overflow-hidden"
                          style={{
                            height: subheadAccording ? "35px" : "fit-content",
                          }}
                        >
                          <div className="col p-0" style={{ width: "20%" }}>
                            radhe krishna
                          </div>
                          <div className="col p-0" style={{ width: "20%" }}>
                            10000
                          </div>
                          <div className="col p-0" style={{ width: "20%" }}>
                            10000
                          </div>
                          <div className="col p-0" style={{ width: "20%" }}>
                            10000
                          </div>
                          <div className="col p-0" style={{ width: "20%" }}>
                            10000
                          </div>
                          <div
                            className="col p-0 text-success-100"
                            style={{ width: "20%" }}
                          >
                            10000
                          </div>
                        </div>

                        <div
                          className="row fs-14px p-1 fw-500 overflow-hidden bg-info-20"
                          style={{
                            height: subheadAccording ? "35px" : "fit-content",
                          }}
                        >
                          <div className="col p-0" style={{ width: "20%" }}>
                            Total
                          </div>
                          <div className="col p-0" style={{ width: "20%" }}>
                            10000
                          </div>
                          <div className="col p-0" style={{ width: "20%" }}>
                            10000
                          </div>
                          <div className="col p-0" style={{ width: "20%" }}>
                            10000
                          </div>
                          <div className="col p-0" style={{ width: "20%" }}>
                            10000
                          </div>
                          <div
                            className="col p-0 text-success-100"
                            style={{ width: "20%" }}
                          >
                            10000
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                <Accordion activeKey={activeKeys} style={{ border: "0" }}>
                  <Accordion.Item
                    eventKey="21"
                    style={{ borderRadius: "0", border: "0" }}
                  >
                    <Accordion.Header
                      onClick={() => toggleAccordion("21")}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        position: "relative",
                        borderRadius: "0",
                      }}
                    >
                      <div className="w-100 d-flex justify-content-between">
                        <span>Interest deposit </span>
                        <span
                          className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                          style={{ height: "13.33px", width: "13.33px" }}
                        >
                          {activeKeys.includes("21") ? "-" : "+"}
                        </span>
                      </div>
                    </Accordion.Header>

                    <Accordion.Body>
                      <div>

                        <div className="row fs-12px text-black-60 p-1 mt-1">
                          <div
                            className="col text-start p-0"
                            style={{ width: "20%" }}
                          >
                            Challan No.
                          </div>
                          <div
                            className="col text-start p-0"
                            style={{ width: "20%" }}
                          >
                            Receipt head
                          </div>
                          <div
                            className="col text-start p-0"
                            style={{ width: "20%" }}
                          >
                            Date
                          </div>
                          <div
                            className="col text-start p-0"
                            style={{ width: "20%" }}
                          >
                            Amount
                          </div>
                        </div>

                        <div
                          className="row fs-14px p-1 fw-500 overflow-hidden"
                          style={{
                            height: subheadAccording ? "35px" : "fit-content",
                          }}
                        >
                 
                          <div className="col p-0" style={{ width: "20%" }}>
                            radhe krishna
                          </div>
                          <div className="col p-0" style={{ width: "20%" }}>
                            10000
                          </div>
                          <div className="col p-0" style={{ width: "20%" }}>
                            10000
                          </div>
                          <div
                            className="col p-0 text-success-100"
                            style={{ width: "20%" }}
                          >
                            10000
                          </div>
                        </div>

                        <div
                          className="row fs-14px p-1 fw-500 overflow-hidden bg-info-20"
                          style={{
                            height: subheadAccording ? "35px" : "fit-content",
                          }}
                        >
                          <div className="col p-0" style={{ width: "20%" }}>
                            Total
                          </div>
                          <div className="col p-0" style={{ width: "20%" }}>
                            10000
                          </div>
                          <div className="col p-0" style={{ width: "20%" }}>
                            10000
                          </div>
                          <div
                            className="col p-0 text-success-100"
                            style={{ width: "20%" }}
                          >
                            10000
                          </div>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
          </div>
        */}
        </div>
      </div>
        </div>
    );
};

export default ReconciliationOverlay;
